/**
 * @desc 匹配规则DTO展示
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(body: Array<defs.wms.WarehouseRulesDetailShowDto>, options?: any) {
  return updateResponse(
    http(URL + `/warehouseRules/rulesShow`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
